import script from "./EditViolation.vue?vue&type=script&setup=true&lang=js"
export * from "./EditViolation.vue?vue&type=script&setup=true&lang=js"

import "./EditViolation.vue?vue&type=style&index=0&id=301170ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-301170ec"]])

export default __exports__